import React, {Component} from "react";
import Select from 'react-select';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {confirmAlert} from "react-confirm-alert";

import {createForm, addValue, getDirections} from "../actions";

import LoadingDots from "./ui/LoadingDots";
import {CompanyInfo} from './program/CompanyInfo';

class RequestCreate extends Component {
  modal;

  state = {
    selectedDirection: null,
  }

  componentDidMount() {
    this.props.getDirections();
  }

  onSelect = (state, value) => {
    const toSet = {};
    toSet[state] = value ? value : null;
    this.setState(toSet);
  }

  onCreate = () => {
    this.props.createForm(this.state);
  }

  render() {
    const {companies, loaders, directions, user} = this.props;

    return (
      <LoadingDots show={typeof loaders['companies'] !== 'undefined' || !this.props.modeLoaded}>
        {companies.length > 0 && (
          <div className="text-block">
            <div className="from-group">
              <div className="row">
                <div className="col-sm-3 col-xs-12">
                  <>
                    <button
                      type="button"
                      className="btn btn-success btn-sm w-btn"
                      onClick={this.onCreate}
                    >
                      Создать заявку
                    </button>
                  </>
                </div>
              </div>
            </div>
          </div>
        )}
        {companies.length === 0 && (
          <div className='text-block text-block_empty'>
            Не найдено ни одной компании
          </div>
        )}
        <CompanyInfo
          ref={(modal) => this.modal = modal }
          programUid={0}
          onSend={this.onCreateEntity}
        />

      </LoadingDots>
    )
  }
}

RequestCreate.propTypes = {
  companies: PropTypes.array.isRequired,
  loaders: PropTypes.shape({}).isRequired,
  forms: PropTypes.array.isRequired,
  directions: PropTypes.array,
  user: PropTypes.shape({}).isRequired,
  createForm: PropTypes.func.isRequired,
  getDirections: PropTypes.func.isRequired
};

RequestCreate.defaultProps = {
  directions: []
};

const mapDispatchToProps = {
  createForm,
  addValue,
  getDirections,
};

function mapStateToProps(state) {
  return {
    companies: state.forms.companies,
    loaders: state.forms.loaders,
    forms: state.forms.forms,
    modeLoaded: state.forms.modeLoaded,
    flows: state.forms.flows,
    directions: state.forms.directions,
    user: state.forms.user,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestCreate);
